import VehicleAddons from "./VehicleAddons";

export default VehicleAddons;
